import { Textarea } from '@hakimo-ui/shared/ui-base';
import clsx from 'clsx';
import { MAX_SMS_LENGTH } from './constants';
import { visibleLength } from './sms-util';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export function MessageField({ value, onChange }: Props) {
  const messageLength = visibleLength(value);
  const isNearCharLimit = messageLength >= MAX_SMS_LENGTH - 20;

  return (
    <>
      <Textarea
        rows={3}
        value={value}
        onChange={onChange}
        placeholder="Write your message here..."
      />
      <div
        className={clsx(
          'pt-1 text-right text-xs',
          isNearCharLimit
            ? 'text-status-warning-600 dark:text-status-warning-400'
            : 'text-onlight-text-3 dark:text-ondark-text-3'
        )}
      >
        {messageLength}/{MAX_SMS_LENGTH} characters
      </div>
    </>
  );
}

export default MessageField;
